import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { Box, Button, ContentTemplate, Progress, TitleHeader } from 'web-library';
import { RequestTypeMode } from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import UserGroupFunctionPermissionAccessOptionsDataTable from 'web-library/components/UserGroupFunctionPermissionAccessOptionsDataTable';
import { REQUEST_TYPES } from 'web-library/models/Request';
import TransactionAuditLogUpdatedDetails from 'web-library/components/TransactionAuditLogUpdatedDetails';
import { useGetUserGroupAuthorities } from '../../api-refactored/user-group-access-configuration/useGetUserGroupAuthorities';
import RouteKey from '../../routes/key';
import TransactionLogModal from '../../components/TransactionLogModal';

const useStyles = makeStyles()((theme) =>
({
  backButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
  submitButtonContainer: {
    width: '100%',
    display: 'flex',
    marginTop: theme.spacing(2),
    marginBottom: '120px',
  },
}));

const { userGroupAccessConfiguration } = RouteKey.admin.child;
const { admin } = RouteKey.child;

const AdminViewAccessConfigurations = () => {
  const { uuid: groupUuid } = useParams<any>();
  const { classes } = useStyles();
  const { t } = useTranslation();
  const history = useHistory();

  const [openTransactionLogModal, setOpenTransactionLogModal] = useState<boolean>(false);

  const {
    data: groupAuthoritiesData,
    isLoading: groupAuthoritiesLoading,
  } = useGetUserGroupAuthorities({
    uuid: groupUuid,
  });

  if (groupAuthoritiesLoading) {
    return <Progress color="secondary" />;
  }

  return (
    <>
      <TitleHeader title={groupAuthoritiesData?.userGroupDisplayName || ''} />
      <ContentTemplate type="full">
        <UserGroupFunctionPermissionAccessOptionsDataTable
          data={groupAuthoritiesData?.content || []}
          editable={false}
        />

        <TransactionAuditLogUpdatedDetails
          updatedAt={groupAuthoritiesData?.updatedAt as string}
          updatedBy={groupAuthoritiesData?.updatedBy as string}
          handleOpenLogModal={() => setOpenTransactionLogModal(true)}
          label={t('admin->>UserGroups.ViewTransactionLog')}
        />

        <Box className={classes.submitButtonContainer}>
          <Button
            className={classes.backButton}
            id="button-create-new-announcement-cancel"
            variant="outlined"
            onClick={() =>
              history.push(`/${admin}/${userGroupAccessConfiguration.route}`, {
                requestType: RequestTypeMode.AdminAccessConfiguration,
              })
            }
          >
            {t('admin->>UserGroups.BackToListing')}
          </Button>
        </Box>
      </ContentTemplate>
      {openTransactionLogModal && (
        <TransactionLogModal
          modalState={openTransactionLogModal}
          setOpenModalState={setOpenTransactionLogModal}
          requestType={REQUEST_TYPES.ADMIN_ACCESS_CONFIG}
        />
      )}
    </>
  );
};

export default AdminViewAccessConfigurations;
